let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2nRwY")).then(() => parcelRequire('5L9dB'));